import { type FC } from 'react';
import {
  CalendarBlank
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconCalendarBlankProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconCalendarBlank: FC<UiIconCalendarBlankProps> = (props) => {
  return (
    <UiIcon
      IconComponent={CalendarBlank}
      {...props}
    />
  );
};
